import { render, staticRenderFns } from "./batchAddWorker.vue?vue&type=template&id=158efa6c&scoped=true&"
import script from "./batchAddWorker.vue?vue&type=script&lang=js&"
export * from "./batchAddWorker.vue?vue&type=script&lang=js&"
import style0 from "./batchAddWorker.vue?vue&type=style&index=0&id=158efa6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158efa6c",
  null
  
)

export default component.exports